import { render, staticRenderFns } from "./addSQR.vue?vue&type=template&id=d2105a26&scoped=true&"
import script from "./addSQR.vue?vue&type=script&lang=js&"
export * from "./addSQR.vue?vue&type=script&lang=js&"
import style0 from "./addSQR.vue?vue&type=style&index=0&id=d2105a26&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2105a26",
  null
  
)

export default component.exports